import Api from './Api'
// import Vue from 'vue'
import axios from 'axios'
import AclService from './AclService'
import InstillingerService from './InstillingerService'

export default {
  index () {
    return Api().get('/bruker.json')
  },

  view (id) {
    return Api().get('/bruker/' + id + '.json')
  },

  save (id, data) {
    if (!id) {
      return Api().post('/bruker.json', data)
    }

    return Api().put('/bruker/' + id + '.json', data)
  },

  dropdown (theKey, ekspert) {
    if (!theKey || !(theKey === 'Brukernavn' || theKey === 'Brukerid')) {
      theKey = 'Brukerid'
    }

    if (ekspert) {
      ekspert = '&ekspert=' + ekspert
    }

    return Api().get('/bruker/dropdown.json?key=' + theKey + ekspert)
  },

  experts () {
    return Api().get('/bruker/experts.json')
  },

  findByEmail (email) {
    return Api().get('/bruker/find_by_email.json', {
      params: {
        email: email
      }
    })
  },

  findByBrukernavn (brukernavn) {
    return Api().get('/bruker/find_by_brukernavn.json', {
      params: {
        brukernavn: brukernavn
      }
    })
  },

  loadFormDropdowns () {
    return new Promise((resolve, reject) => {
      axios
        .all([
          InstillingerService('avdeling').dropdown(),
          AclService.dropdown()
        ])
        .then(
          axios.spread(function (avdeling, rolle) {
            let payload = {
              avdeling: avdeling.data,
              rolle: rolle.data
            }

            resolve(payload)
          })
        )
        .catch(error => {
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/BrukerService.js